import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import {
  parseTime,
  TimePeriod,
  timeWithMonth,
  timeWithYear,
  zeroTime,
} from '@/components/Forms/QuestionType/CrewType';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewTimeInput',
  props: {
  value: String as PropType<TimePeriod>,
  prev: Boolean,
},
  emits: {
  input: (value: TimePeriod) => true,
},
  setup(__props, { emit }) {

const props = __props;





const years = computed({
  get() {
    return parseTime(props.value).Y;
  },
  set(v) {
    emit('input', timeWithYear(props.value, v));
  },
});
const months = computed({
  get() {
    return parseTime(props.value).M;
  },
  set(v) {
    emit('input', timeWithMonth(props.value, v));
  },
});

function numOnly(e: InputEvent) {
  if (e.data === null) return;
  if (!/^\d*$/.test(e.data)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}

const zero = computed(() => zeroTime(props.value));

return { __sfc: true,props, emit, years, months, numOnly, zero }
}

})